// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { BlogMenuFragmentDoc } from '../../../../../components/cms/component/blog/BlogMenu.generated';
export const PostCategoriesFragmentDoc = gql`
    fragment postCategories on Query {
  postCategories(locale: $locale) {
    ...blogMenu
  }
}
    ${BlogMenuFragmentDoc}`;